import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { IResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';
import { IUserFieldsValidatorDto } from '@models/portal/validator/dto/user-fields-validator-dto';
import { IUserPendingValidationsDto } from '@models/portal/validator/dto/user-pending-validation-dto';
import { IUserFieldsValidatorFilter } from '@models/portal/validator/filters/user-fields-validator-filter';
import { UserFieldsValidatorForm } from '@models/portal/validator/form/user-fields-validator-form';
import { UserStepValidationEnum } from '@modules/user/user-form/user-form.component';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { map, Observable } from 'rxjs';

import { toParams, url } from 'src/app/core/utilities/utility-functions';

@Injectable({
  providedIn: 'root'
})
export class UserValidatorFieldsService {

  #baseUrl = environment.apiUrl.concat('/v1/usuario-validadores');

  #http = inject(HttpClient);

  fetchAllValidators$(pageRequest: PageRequest, filters?: IUserFieldsValidatorFilter): Observable<IPage<IUserFieldsValidatorDto>> {
    return this.#http.get<IResponseDto<IPage<IUserFieldsValidatorDto>>>(this.#baseUrl, { params: toParams(pageRequest, filters) }).pipe(extractResponse());
  }

  fetchValidatorById$(uvcNrId: number): Observable<IUserFieldsValidatorDto> {
    return this.#http.get<IResponseDto<IUserFieldsValidatorDto>>(url(this.#baseUrl, uvcNrId)).pipe(extractResponse());
  }

  validateUserRegistration$(uvcNrId: number, usuNrId: number, uvcListEtapas?: UserStepValidationEnum[]): Observable<IUserPendingValidationsDto> {
    let params = new HttpParams();
    if (uvcListEtapas) {
      params = params.set('uvcListEtapas', uvcListEtapas.join(','));
    }
    return this.#http.get<IResponseDto<IUserPendingValidationsDto>>(url(this.#baseUrl, uvcNrId, 'usuarios', usuNrId), { params }).pipe(extractResponse());
  }

  registerValidator$(form: UserFieldsValidatorForm): Observable<IUserFieldsValidatorDto> {
    return this.#http.post<IResponseDto<IUserFieldsValidatorDto>>(this.#baseUrl, form).pipe(extractResponse());
  }

  updateValidator$(form: UserFieldsValidatorForm): Observable<IUserFieldsValidatorDto> {
    return this.#http.put<IResponseDto<IUserFieldsValidatorDto>>(this.#baseUrl, form).pipe(extractResponse());
  }

  deleteValidator$(form: UserFieldsValidatorForm): Observable<void> {
  return this.#http.delete(this.#baseUrl, { body: form }).pipe(
    map(() => undefined)// Equivalente ao mapTo(undefined), mas sem depreciação
  );
}
}



